import React from 'react';
import '../../css/BdStyles.css';

const BdAdminPage = () => {
  return (
    <div className="bd">
    <div>
      <h1>Acceso permitido</h1>
      <h4>Saludos, ya puedes insertar, modificar y eliminar registros.
      Por seguridad, no olvides pulsar el botón Logout al terminar.</h4>
    </div>
    </div>
  );
};

export default BdAdminPage;